import React from 'react';
import styled from 'styled-components/macro';
import { isMobile } from 'react-device-detect';
import { HashLink as Link } from 'react-router-hash-link';

const RecentWorkLinkContainer = styled.div`
  opacity: ${(props) => (props.visible ? '0' : '1')};
  visibility: ${(props) => (props.visible ? 'hidden' : 'visible')};
  position: ${() => (isMobile ? 'absolute' : 'relative')};
  bottom: ${() => (isMobile ? '20px' : '')};
  margin-top: 40px;
  text-align: center;
  width: 100%;
  z-index: 2;
  transition: 0.5s;

  @media (max-height: 440px) {
    position: ${() => (isMobile ? 'relative' : '')};
  }

  @media (max-height: 540px) {
    bottom: ${() => (isMobile ? '0px' : '')};
  }
`;

const RecentWork = styled(Link)`
  color: #861657;
  font-size: 20px;
  font-family: miller-display, serif;
  font-weight: 400;
  line-height: 20px;

  :hover {
    color: ${() => (!isMobile ? '#93e1d8' : '')};
  }

  :active {
    color: #93e1d8;
  }
`;

const ArrowContainer = styled.div`
  > i {
    margin-top: 0;
    font-size: 60px;

    @media (max-height: 540px) {
      margin-top: ${() => (isMobile ? '-20px' : '')};
    }

    @media (max-height: 440px) {
      margin-top: ${() => (isMobile ? '0px' : '')};
    }
  }
`;

const RecentWorkLink = (props) => {
  return (
    <RecentWorkLinkContainer
      visible={props.visible}
      onClick={props.linkOnClick}
    >
      {/* <RecentWork smooth to="/#work"> */}
      <RecentWork
        scroll={(el) =>
          // el.scrollIntoView({ behavior: 'instant', block: 'end' })
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
        to="/#work"
      >
        Recent Work
        <ArrowContainer>
          <i className="fa fa-angle-down"></i>
        </ArrowContainer>
      </RecentWork>
    </RecentWorkLinkContainer>
  );
};

export default RecentWorkLink;
